import React from 'react'

import { HStack, Icon, Text, VStack } from '@chakra-ui/react'
import { IoIosArrowForward } from 'react-icons/io'
import { IconType } from 'react-icons/lib'

interface IconItemListProps {
    list: string[]
    icon?: IconType
    iconColor?: string
    gap?: string
    align?: string
    textColor?: string
    mx?: string
    maxW?: string | string[]
}

const IconItemList = ({
    list,
    icon = IoIosArrowForward,
    iconColor = 'indigo.500',
    gap = '1',
    align = 'start',
    textColor = 'indigo.500',
    ...rest
}: IconItemListProps) => (
    <VStack align="start" {...rest}>
        {list?.map((item, index) => (
            <HStack key={index} align={align} px="1" gap={gap}>
                <Icon as={icon} color={iconColor} mt="0.3" />

                <Text fontSize={['xs', 'sm']} color={textColor}>
                    {item}
                </Text>
            </HStack>
        ))}
    </VStack>
)

export default IconItemList
